export { default } from './StyledTabs';
